// components/NotificationToggleButton.tsx
import React, { useState, useEffect } from 'react';
import { Button } from '@chakra-ui/react';
import { getMessaging, deleteToken } from 'firebase/messaging';
import { app, requestPermission } from '../../src/firebase';       // your initialized Firebase app
import { getHeadersForRequest } from '../utils/functions';
import axios from 'axios';

export const NotificationToggleButton: React.FC = () => {
  // track permission: "default" | "granted" | "denied"
  const [permission, setPermission] = useState(Notification.permission);

  useEffect(() => {
    // listen for external changes (e.g. user revokes in browser settings)
    if ('permissions' in navigator) {
      navigator.permissions
        .query({ name: 'notifications' as PermissionName })
        .then(status => {
          status.onchange = () => setPermission(Notification.permission);
        });
    }
  }, []);

  const handleClick = async () => {
    if (permission !== 'granted') {
      // 🟢 Ask to enable
      const newPerm = await Notification.requestPermission();
      setPermission(newPerm);
      if (newPerm === 'granted') {
        await requestPermission();    // your FCM token fetcher
      }
    } else {
      // 🔴 “Disable” by deleting the FCM token
      try {
        const messaging = getMessaging(app);
        const deleted = await deleteToken(messaging);
        console.log('FCM token deleted:', deleted);
      } catch (err) {
        console.error('Error deleting FCM token:', err);
      }
      // browser permission stays “granted” but you won't get pushes
      setPermission('default');
    }
  };

  const testNotificationToAll = async () => {
    const headers = await getHeadersForRequest();
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_TEST_API_URL}/notifications/testAll`,
        { headers }
      );

      
    } catch (error) {
      console.error("Notification sending error:", error);
    }
  }

  const testNotification = async () => {
    const savedToken = localStorage.getItem("fcmToken");

    const oldHeaders = await getHeadersForRequest();

    const newHeaders = {token: savedToken};

    const headers = { ...oldHeaders, ...newHeaders };
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_TEST_API_URL}/notifications/test`,
        { headers }
      );

      console.log(response);
    } catch (error) {
      console.error("Notification sending error:", error);
    }
  }

  return (
    <>
      <Button onClick={handleClick}>
        {permission === "granted"
          ? "Disable Notifications"
          : "Enable Notifications"}
      </Button>

      {permission === "granted" && (
        <Button onClick={testNotificationToAll}>Send Test Notificaion to All Devices</Button>
      )}
      {permission === "granted" && (
        <Button onClick={testNotification}>Send Test Notificaion To This Device</Button>
      )}
    </>
  );
};
